var W = Object.prototype.hasOwnProperty;
function _(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && _(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (W.call(e, n) && ++o && !W.call(t, n) || !(n in t) || !_(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
const K = Symbol("clean");
let N = [], I = 0;
const $ = 4, ee = globalThis.nanostoresGlobal || (globalThis.nanostoresGlobal = { epoch: 0 });
let te = () => {
  for (I = 0; I < N.length; I += $)
    N[I](
      N[I + 1].value,
      N[I + 2],
      N[I + 3]
    );
  N.length = 0;
};
const M = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  let t = [], n = {
    get() {
      return n.lc || n.listen(() => {
      })(), n.value;
    },
    init: e,
    lc: 0,
    listen(o) {
      return n.lc = t.push(o), () => {
        for (let f = I + $; f < N.length; )
          N[f] === o ? N.splice(f, $) : f += $;
        let d = t.indexOf(o);
        ~d && (t.splice(d, 1), --n.lc || n.off());
      };
    },
    notify(o, d) {
      ee.epoch++;
      let f = !N.length && !0;
      for (let A of t)
        N.push(
          A,
          n,
          o,
          d
        );
      f && te();
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(o) {
      let d = n.value;
      d !== o && (n.value = o, n.notify(d));
    },
    subscribe(o) {
      let d = n.listen(o);
      return o(n.value), d;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (n[K] = () => {
    t = [], n.lc = 0, n.off();
  }), n;
}, De = (e) => {
  const t = /* @__PURE__ */ M(null);
  return e.observe(({ changes: n }) => {
    const o = t.get();
    if (o) {
      (n.deleted || []).some((A) => A.id === o) && t.set(null);
      const f = (n.updated || []).find(({ oldValue: A }) => A.id === o);
      f && t.set(f.newValue.id);
    }
  }), {
    get current() {
      return t.get();
    },
    subscribe: t.subscribe.bind(t),
    set: t.set.bind(t)
  };
};
var ne = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(ne || {});
const z = { selected: [] }, Ne = (e, t, n) => {
  const o = /* @__PURE__ */ M(z);
  let d = t;
  const f = () => {
    _(o.get(), z) || o.set(z);
  }, A = () => {
    var g;
    return ((g = o.get().selected) == null ? void 0 : g.length) === 0;
  }, w = (g) => {
    if (A())
      return !1;
    const E = typeof g == "string" ? g : g.id;
    return o.get().selected.some((L) => L.id === E);
  }, C = (g, E) => {
    let L;
    if (Array.isArray(g)) {
      if (L = g.map((i) => e.getAnnotation(i)).filter(Boolean), L.length < g.length) {
        console.warn("Invalid selection: " + g.filter((i) => !L.some((u) => u.id === i)));
        return;
      }
    } else {
      const i = e.getAnnotation(g);
      if (!i) {
        console.warn("Invalid selection: " + g);
        return;
      }
      L = [i];
    }
    const O = L.reduce((i, u) => {
      const h = b(u);
      return h === "EDIT" ? [...i, { id: u.id, editable: !0 }] : h === "SELECT" ? [...i, { id: u.id }] : i;
    }, []);
    o.set({ selected: O, event: E });
  }, m = (g, E) => {
    const L = Array.isArray(g) ? g : [g], O = L.map((i) => e.getAnnotation(i)).filter((i) => !!i);
    o.set({
      selected: O.map((i) => {
        const u = E === void 0 ? b(i) === "EDIT" : E;
        return { id: i.id, editable: u };
      })
    }), O.length !== L.length && console.warn("Invalid selection", g);
  }, S = (g) => {
    if (A())
      return !1;
    const { selected: E } = o.get();
    E.some(({ id: O }) => g.includes(O)) && o.set({ selected: E.filter(({ id: O }) => !g.includes(O)) });
  }, l = (g) => {
    d = g, m(o.get().selected.map(({ id: E }) => E));
  }, b = (g) => oe(g, d, n);
  return e.observe(
    ({ changes: g }) => S((g.deleted || []).map((E) => E.id))
  ), {
    get event() {
      const g = o.get();
      return g ? g.event : null;
    },
    get selected() {
      const g = o.get();
      return g ? [...g.selected] : null;
    },
    get userSelectAction() {
      return d;
    },
    clear: f,
    evalSelectAction: b,
    isEmpty: A,
    isSelected: w,
    setSelected: m,
    setUserSelectAction: l,
    subscribe: o.subscribe.bind(o),
    userSelect: C
  };
}, oe = (e, t, n) => {
  const o = n ? n.serialize(e) : e;
  return typeof t == "function" ? t(o) : t || "EDIT";
}, B = [];
for (let e = 0; e < 256; ++e)
  B.push((e + 256).toString(16).slice(1));
function se(e, t = 0) {
  return (B[e[t + 0]] + B[e[t + 1]] + B[e[t + 2]] + B[e[t + 3]] + "-" + B[e[t + 4]] + B[e[t + 5]] + "-" + B[e[t + 6]] + B[e[t + 7]] + "-" + B[e[t + 8]] + B[e[t + 9]] + "-" + B[e[t + 10]] + B[e[t + 11]] + B[e[t + 12]] + B[e[t + 13]] + B[e[t + 14]] + B[e[t + 15]]).toLowerCase();
}
const ie = new Uint8Array(16);
function de() {
  return crypto.getRandomValues(ie);
}
function Q(e, t, n) {
  return crypto.randomUUID ? crypto.randomUUID() : re(e);
}
function re(e, t, n) {
  var d;
  e = e || {};
  const o = e.random ?? ((d = e.rng) == null ? void 0 : d.call(e)) ?? de();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, se(o);
}
const xe = (e) => {
  const { creator: t, updatedBy: n } = e.target, o = e.bodies.reduce((d, f) => [...d, f.creator, f.updatedBy].filter(Boolean), []);
  return [
    t,
    n,
    ...o
  ].filter((d) => d);
}, V = (e) => {
  const t = (n) => {
    const o = { ...n };
    return n.created && typeof n.created == "string" && (o.created = new Date(n.created)), n.updated && typeof n.updated == "string" && (o.updated = new Date(n.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(t),
    target: t(e.target)
  };
}, Ie = (e, t, n, o) => ({
  id: Q(),
  annotation: typeof e == "string" ? e : e.id,
  created: n || /* @__PURE__ */ new Date(),
  creator: o,
  ...t
}), ae = (e, t) => {
  const n = new Set(e.bodies.map((o) => o.id));
  return t.bodies.filter((o) => !n.has(o.id));
}, ce = (e, t) => {
  const n = new Set(t.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !n.has(o.id));
}, le = (e, t) => t.bodies.map((n) => {
  const o = e.bodies.find((d) => d.id === n.id);
  return { newBody: n, oldBody: o && !_(o, n) ? o : void 0 };
}).filter(({ oldBody: n }) => n).map(({ oldBody: n, newBody: o }) => ({ oldBody: n, newBody: o })), ue = (e, t) => !_(e.target, t.target), q = (e, t) => {
  const n = ae(e, t), o = ce(e, t), d = le(e, t);
  return {
    oldValue: e,
    newValue: t,
    bodiesCreated: n.length > 0 ? n : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: d.length > 0 ? d : void 0,
    targetUpdated: ue(e, t) ? { oldTarget: e.target, newTarget: t.target } : void 0
  };
};
var fe = /* @__PURE__ */ ((e) => (e.BODY_ONLY = "BODY_ONLY", e.TARGET_ONLY = "TARGET_ONLY", e))(fe || {}), y = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(y || {});
const pe = (e, t) => {
  var f, A;
  const { changes: n, origin: o } = t;
  if (!(e.options.origin ? e.options.origin === o : o !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: w } = e.options, C = (S) => S && S.length > 0;
    if (!(C(n.created) || C(n.deleted))) {
      const S = (f = n.updated) == null ? void 0 : f.some((b) => C(b.bodiesCreated) || C(b.bodiesDeleted) || C(b.bodiesUpdated)), l = (A = n.updated) == null ? void 0 : A.some((b) => b.targetUpdated);
      if (w === "BODY_ONLY" && S && !l || w === "TARGET_ONLY" && l && !S)
        return !1;
    }
  }
  if (e.options.annotations) {
    const w = /* @__PURE__ */ new Set([
      ...(n.created || []).map((m) => m.id),
      ...(n.deleted || []).map((m) => m.id),
      ...(n.updated || []).map(({ oldValue: m }) => m.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((m) => w.has(m));
  } else
    return !0;
}, ge = (e, t) => {
  const n = new Set((e.created || []).map((l) => l.id)), o = new Set((e.updated || []).map(({ newValue: l }) => l.id)), d = new Set((t.created || []).map((l) => l.id)), f = new Set((t.deleted || []).map((l) => l.id)), A = new Set((t.updated || []).map(({ oldValue: l }) => l.id)), w = new Set((t.updated || []).filter(({ oldValue: l }) => n.has(l.id) || o.has(l.id)).map(({ oldValue: l }) => l.id)), C = [
    ...(e.created || []).filter((l) => !f.has(l.id)).map((l) => A.has(l.id) ? t.updated.find(({ oldValue: b }) => b.id === l.id).newValue : l),
    ...t.created || []
  ], m = [
    ...(e.deleted || []).filter((l) => !d.has(l.id)),
    ...(t.deleted || []).filter((l) => !n.has(l.id))
  ], S = [
    ...(e.updated || []).filter(({ newValue: l }) => !f.has(l.id)).map((l) => {
      const { oldValue: b, newValue: g } = l;
      if (A.has(g.id)) {
        const E = t.updated.find((L) => L.oldValue.id === g.id).newValue;
        return q(b, E);
      } else
        return l;
    }),
    ...(t.updated || []).filter(({ oldValue: l }) => !w.has(l.id))
  ];
  return { created: C, deleted: m, updated: S };
}, P = (e) => {
  const t = e.id === void 0 ? Q() : e.id;
  return {
    ...e,
    id: t,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((n) => ({
      ...n,
      annotation: t
    })),
    target: {
      ...e.target,
      annotation: t
    }
  };
}, he = (e) => e.id !== void 0, _e = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [], o = (s, r = {}) => {
    n.push({ onChange: s, options: r });
  }, d = (s) => {
    const r = n.findIndex((a) => a.onChange == s);
    r > -1 && n.splice(r, 1);
  }, f = (s, r) => {
    const a = {
      origin: s,
      changes: {
        created: r.created || [],
        updated: r.updated || [],
        deleted: r.deleted || []
      },
      state: [...e.values()]
    };
    n.forEach((p) => {
      pe(p, a) && p.onChange(a);
    });
  }, A = (s) => {
    e.set(s.id, s), s.bodies.forEach((r) => t.set(r.id, s.id));
  }, w = (s, r = y.LOCAL) => {
    if (s.id && e.get(s.id))
      throw Error(`Cannot add annotation ${s.id} - exists already`);
    {
      const p = P(s);
      A(p), f(r, { created: [p] });
    }
  }, C = (s, r) => {
    const a = P(typeof s == "string" ? r : s), p = typeof s == "string" ? s : s.id, T = p && e.get(p);
    if (T) {
      const R = q(T, a);
      return p === a.id ? e.set(p, a) : (e.delete(p), e.set(a.id, a)), T.bodies.forEach((Y) => t.delete(Y.id)), a.bodies.forEach((Y) => t.set(Y.id, a.id)), R;
    } else
      console.warn(`Cannot update annotation ${p} - does not exist`);
  }, m = (s, r = y.LOCAL, a = y.LOCAL) => {
    const p = he(r) ? a : r, T = C(s, r);
    T && f(p, { updated: [T] });
  }, S = (s, r = y.LOCAL) => {
    !!e.get(s.id) ? m(s, r) : w(s, r);
  }, l = (s, r = y.LOCAL) => {
    const a = s.reduce((p, T) => {
      const R = C(T);
      return R ? [...p, R] : p;
    }, []);
    a.length > 0 && f(r, { updated: a });
  }, b = (s) => s.map(P).reduce((a, p) => e.get(p.id) ? { ...a, toUpdate: [...a.toUpdate, p] } : { ...a, toAdd: [...a.toAdd, p] }, { toAdd: [], toUpdate: [] }), g = (s, r = y.LOCAL) => {
    const { toAdd: a, toUpdate: p } = b(s), T = p.map((R) => C(R, r)).filter(Boolean);
    a.forEach(A), f(r, { created: a, updated: T });
  }, E = (s, r = y.LOCAL) => {
    const a = e.get(s.annotation);
    if (a) {
      const p = {
        ...a,
        bodies: [...a.bodies, s]
      };
      e.set(a.id, p), t.set(s.id, p.id), f(r, { updated: [{
        oldValue: a,
        newValue: p,
        bodiesCreated: [s]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${s.annotation}`);
  }, L = () => [...e.values()], O = (s = y.LOCAL) => {
    const r = [...e.values()];
    e.clear(), t.clear(), f(s, { deleted: r });
  }, i = (s, r = y.LOCAL) => {
    const { toAdd: a, toUpdate: p } = b(s), T = new Set([...a, ...p].map((k) => k.id)), R = [...e.keys()].filter((k) => !T.has(k)).map((k) => h(k)).filter(Boolean), Y = p.map((k) => C(k)).filter(Boolean);
    a.forEach(A), f(r, { created: a, updated: Y, deleted: R });
  }, u = (s, r = !0, a = y.LOCAL) => {
    r ? i(s, a) : g(s, a);
  }, h = (s) => {
    const r = typeof s == "string" ? s : s.id, a = e.get(r);
    if (a)
      return e.delete(r), a.bodies.forEach((p) => t.delete(p.id)), a;
    console.warn(`Attempt to delete missing annotation: ${r}`);
  }, v = (s, r = y.LOCAL) => {
    const a = h(s);
    a && f(r, { deleted: [a] });
  }, c = (s, r = y.LOCAL) => {
    const a = s.reduce((p, T) => {
      const R = h(T);
      return R ? [...p, R] : p;
    }, []);
    a.length > 0 && f(r, { deleted: a });
  }, U = (s) => {
    const r = e.get(s.annotation);
    if (r) {
      const a = r.bodies.find((p) => p.id === s.id);
      if (a) {
        t.delete(a.id);
        const p = {
          ...r,
          bodies: r.bodies.filter((R) => R.id !== s.id)
        };
        return e.set(r.id, p), {
          oldValue: r,
          newValue: p,
          bodiesDeleted: [a]
        };
      } else
        console.warn(`Attempt to delete missing body ${s.id} from annotation ${s.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${s.annotation}`);
  }, D = (s, r = y.LOCAL) => {
    const a = U(s);
    a && f(r, { updated: [a] });
  }, x = (s, r = y.LOCAL) => {
    const a = s.map((p) => U(p)).filter(Boolean);
    a.length > 0 && f(r, { updated: a });
  }, j = (s) => {
    const r = e.get(s);
    return r ? { ...r } : void 0;
  }, X = (s) => {
    const r = t.get(s);
    if (r) {
      const p = j(r).bodies.find((T) => T.id === s);
      if (p)
        return p;
      console.error(`Store integrity error: body ${s} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${s}`);
  }, G = (s, r) => {
    if (s.annotation !== r.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const a = e.get(s.annotation);
    if (a) {
      const p = a.bodies.find((R) => R.id === s.id), T = {
        ...a,
        bodies: a.bodies.map((R) => R.id === p.id ? r : R)
      };
      return e.set(a.id, T), p.id !== r.id && (t.delete(p.id), t.set(r.id, T.id)), {
        oldValue: a,
        newValue: T,
        bodiesUpdated: [{ oldBody: p, newBody: r }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${s.annotation}`);
  }, Z = (s, r, a = y.LOCAL) => {
    const p = G(s, r);
    p && f(a, { updated: [p] });
  }, F = (s, r = y.LOCAL) => {
    const a = s.map((p) => G({ id: p.id, annotation: p.annotation }, p)).filter(Boolean);
    f(r, { updated: a });
  }, H = (s) => {
    const r = e.get(s.annotation);
    if (r) {
      const a = {
        ...r,
        target: {
          ...r.target,
          ...s
        }
      };
      return e.set(r.id, a), {
        oldValue: r,
        newValue: a,
        targetUpdated: {
          oldTarget: r.target,
          newTarget: s
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${s.annotation}`);
  };
  return {
    addAnnotation: w,
    addBody: E,
    all: L,
    bulkAddAnnotations: u,
    bulkDeleteAnnotations: c,
    bulkDeleteBodies: x,
    bulkUpdateAnnotations: l,
    bulkUpdateBodies: F,
    bulkUpdateTargets: (s, r = y.LOCAL) => {
      const a = s.map((p) => H(p)).filter(Boolean);
      a.length > 0 && f(r, { updated: a });
    },
    bulkUpsertAnnotations: g,
    clear: O,
    deleteAnnotation: v,
    deleteBody: D,
    getAnnotation: j,
    getBody: X,
    observe: o,
    syncAnnotations: i,
    unobserve: d,
    updateAnnotation: m,
    updateBody: Z,
    updateTarget: (s, r = y.LOCAL) => {
      const a = H(s);
      a && f(r, { updated: [a] });
    },
    upsertAnnotation: S
  };
};
let J = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, d = n.length; o < d; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    var n;
    return ((n = this.events)[e] || (n[e] = [])).push(t), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((d) => t !== d);
    };
  }
});
const Ae = 250, ke = (e, t) => {
  const n = J(), o = (t == null ? void 0 : t.changes) || [];
  let d = t ? t.pointer : -1, f = !1, A = 0;
  const w = (c) => {
    if (!f) {
      const { changes: U } = c, D = performance.now();
      if (D - A > Ae)
        o.splice(d + 1), o.push(U), d = o.length - 1;
      else {
        const x = o.length - 1;
        o[x] = ge(o[x], U);
      }
      A = D;
    }
    f = !1;
  };
  e.observe(w, { origin: y.LOCAL });
  const C = (c) => c && c.length > 0 && e.bulkDeleteAnnotations(c), m = (c) => c && c.length > 0 && e.bulkUpsertAnnotations(c), S = (c) => c && c.length > 0 && e.bulkUpdateAnnotations(c.map(({ oldValue: U }) => U)), l = (c) => c && c.length > 0 && e.bulkUpdateAnnotations(c.map(({ newValue: U }) => U)), b = (c) => c && c.length > 0 && e.bulkUpsertAnnotations(c), g = (c) => c && c.length > 0 && e.bulkDeleteAnnotations(c);
  return {
    canRedo: () => o.length - 1 > d,
    canUndo: () => d > -1,
    destroy: () => e.unobserve(w),
    getHistory: () => ({ changes: [...o], pointer: d }),
    on: (c, U) => n.on(c, U),
    redo: () => {
      if (o.length - 1 > d) {
        f = !0;
        const { created: c, updated: U, deleted: D } = o[d + 1];
        m(c), l(U), g(D), n.emit("redo", o[d + 1]), d += 1;
      }
    },
    undo: () => {
      if (d > -1) {
        f = !0;
        const { created: c, updated: U, deleted: D } = o[d];
        C(c), S(U), b(D), n.emit("undo", o[d]), d -= 1;
      }
    }
  };
}, Ye = () => {
  const e = /* @__PURE__ */ M([]);
  return {
    subscribe: e.subscribe.bind(e),
    set: e.set.bind(e)
  };
}, Pe = (e, t, n, o) => {
  const { hover: d, selection: f, store: A, viewport: w } = e, C = /* @__PURE__ */ new Map();
  let m = [], S, l;
  const b = (i, u) => {
    C.has(i) ? C.get(i).push(u) : C.set(i, [u]);
  }, g = (i, u) => {
    const h = C.get(i);
    if (h) {
      const v = h.indexOf(u);
      v !== -1 && h.splice(v, 1);
    }
  }, E = (i, u, h) => {
    C.has(i) && setTimeout(() => {
      C.get(i).forEach((v) => {
        if (n) {
          const c = Array.isArray(u) ? u.map((D) => n.serialize(D)) : n.serialize(u), U = h ? h instanceof PointerEvent ? h : n.serialize(h) : void 0;
          v(c, U);
        } else
          v(u, h);
      });
    }, 1);
  }, L = () => {
    const { selected: i } = f, u = (i || []).map(({ id: h }) => A.getAnnotation(h));
    u.forEach((h) => {
      const v = m.find((c) => c.id === h.id);
      (!v || !_(v, h)) && E("updateAnnotation", h, v);
    }), m = m.map((h) => {
      const v = u.find(({ id: c }) => c === h.id);
      return v || h;
    });
  };
  f.subscribe(({ selected: i }) => {
    if (!(m.length === 0 && i.length === 0)) {
      if (m.length === 0 && i.length > 0)
        m = i.map(({ id: u }) => A.getAnnotation(u));
      else if (m.length > 0 && i.length === 0)
        m.forEach((u) => {
          const h = A.getAnnotation(u.id);
          h && !_(h, u) && E("updateAnnotation", h, u);
        }), m = [];
      else {
        const u = new Set(m.map((c) => c.id)), h = new Set(i.map(({ id: c }) => c));
        m.filter((c) => !h.has(c.id)).forEach((c) => {
          const U = A.getAnnotation(c.id);
          U && !_(U, c) && E("updateAnnotation", U, c);
        }), m = [
          // Remove annotations that were deselected
          ...m.filter((c) => h.has(c.id)),
          // Add editable annotations that were selected
          ...i.filter(({ id: c }) => !u.has(c)).map(({ id: c }) => A.getAnnotation(c))
        ];
      }
      E("selectionChanged", m);
    }
  }), d.subscribe((i) => {
    !S && i ? E("mouseEnterAnnotation", A.getAnnotation(i)) : S && !i ? E("mouseLeaveAnnotation", A.getAnnotation(S)) : S && i && (E("mouseLeaveAnnotation", A.getAnnotation(S)), E("mouseEnterAnnotation", A.getAnnotation(i))), S = i;
  }), w == null || w.subscribe((i) => E("viewportIntersect", i.map((u) => A.getAnnotation(u)))), A.observe((i) => {
    o && (l && clearTimeout(l), l = setTimeout(L, 1e3));
    const { created: u, deleted: h } = i.changes;
    (u || []).forEach((c) => E("createAnnotation", c)), (h || []).forEach((c) => E("deleteAnnotation", c)), (i.changes.updated || []).filter((c) => [
      ...c.bodiesCreated || [],
      ...c.bodiesDeleted || [],
      ...c.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: c, newValue: U }) => {
      const D = m.find((x) => x.id === c.id) || c;
      m = m.map((x) => x.id === c.id ? U : x), E("updateAnnotation", U, D);
    });
  }, { origin: y.LOCAL }), A.observe((i) => {
    if (m) {
      const u = new Set(m.map((v) => v.id)), h = (i.changes.updated || []).filter(({ newValue: v }) => u.has(v.id)).map(({ newValue: v }) => v);
      h.length > 0 && (m = m.map((v) => {
        const c = h.find((U) => U.id === v.id);
        return c || v;
      }));
    }
  }, { origin: y.REMOTE });
  const O = (i) => (u) => {
    const { updated: h } = u;
    i ? (h || []).forEach((v) => E("updateAnnotation", v.oldValue, v.newValue)) : (h || []).forEach((v) => E("updateAnnotation", v.newValue, v.oldValue));
  };
  return t.on("undo", O(!0)), t.on("redo", O(!1)), { on: b, off: g, emit: E };
}, $e = (e) => (t) => t.map((n) => e.serialize(n)), me = (e) => (t) => t.reduce((n, o) => {
  const { parsed: d, error: f } = e.parse(o);
  return f ? {
    parsed: n.parsed,
    failed: [...n.failed, o]
  } : d ? {
    parsed: [...n.parsed, d],
    failed: n.failed
  } : {
    ...n
  };
}, { parsed: [], failed: [] }), ze = (e, t, n) => {
  const { store: o, selection: d } = e, f = (i) => {
    if (n) {
      const { parsed: u, error: h } = n.parse(i);
      u ? o.addAnnotation(u, y.REMOTE) : console.error(h);
    } else
      o.addAnnotation(V(i), y.REMOTE);
  }, A = () => d.clear(), w = () => o.clear(), C = (i) => {
    const u = o.getAnnotation(i);
    return n && u ? n.serialize(u) : u;
  }, m = () => n ? o.all().map(n.serialize) : o.all(), S = () => {
    var h;
    const u = (((h = d.selected) == null ? void 0 : h.map((v) => v.id)) || []).map((v) => o.getAnnotation(v)).filter(Boolean);
    return n ? u.map(n.serialize) : u;
  }, l = (i, u = !0) => fetch(i).then((h) => h.json()).then((h) => (g(h, u), h)), b = (i) => {
    if (typeof i == "string") {
      const u = o.getAnnotation(i);
      if (o.deleteAnnotation(i), u)
        return n ? n.serialize(u) : u;
    } else {
      const u = n ? n.parse(i).parsed : i;
      if (u)
        return o.deleteAnnotation(u), i;
    }
  }, g = (i, u = !0) => {
    const h = u ? o.syncAnnotations : o.bulkUpsertAnnotations;
    if (n) {
      const v = n.parseAll || me(n), { parsed: c, failed: U } = v(i);
      U.length > 0 && console.warn(`Discarded ${U.length} invalid annotations`, U), h(c, y.REMOTE);
    } else
      h(i.map(V), y.REMOTE);
  }, E = (i, u) => {
    i ? d.setSelected(i, u) : d.clear();
  }, L = (i) => {
    d.setUserSelectAction(i);
  }, O = (i) => {
    if (n) {
      const u = n.parse(i).parsed, h = n.serialize(o.getAnnotation(u.id));
      return o.updateAnnotation(u), h;
    } else {
      const u = o.getAnnotation(i.id);
      return o.updateAnnotation(V(i)), u;
    }
  };
  return {
    addAnnotation: f,
    cancelSelected: A,
    canRedo: t.canRedo,
    canUndo: t.canUndo,
    clearAnnotations: w,
    getAnnotationById: C,
    getAnnotations: m,
    getHistory: t.getHistory,
    getSelected: S,
    loadAnnotations: l,
    redo: t.redo,
    removeAnnotation: b,
    setAnnotations: g,
    setSelected: E,
    setUserSelectAction: L,
    undo: t.undo,
    updateAnnotation: O
  };
}, Ve = (e, t, n) => typeof t == "function" ? t(e, n) : t, Me = (e, t) => typeof e != "function" && typeof t != "function" ? {
  ...e || {},
  ...t || {}
} : (n, o) => {
  const d = typeof e == "function" ? e(n, o) : e, f = typeof t == "function" ? t(n, o) : t;
  return {
    ...d || {},
    ...f || {}
  };
};
let Ee = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", be = (e) => crypto.getRandomValues(new Uint8Array(e)), ve = (e, t, n) => {
  let o = 256 - 256 % e.length;
  if (o === 256) {
    let f = e.length - 1;
    return (A = t) => {
      if (!A) return "";
      let w = "";
      for (; ; ) {
        let C = n(A), m = A;
        for (; m--; )
          if (w += e[C[m] & f], w.length >= A) return w;
      }
    };
  }
  let d = Math.ceil(1.6 * 256 * t / o);
  return (f = t) => {
    if (!f) return "";
    let A = "";
    for (; ; ) {
      let w = n(d), C = d;
      for (; C--; )
        if (w[C] < o && (A += e[w[C] % e.length], A.length >= f))
          return A;
    }
  };
}, Ce = (e, t = 21) => ve(e, t | 0, be), we = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += Ee[n[e] & 63];
  return t;
};
const je = () => ({ isGuest: !0, id: Ce("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), Le = (e) => {
  const t = JSON.stringify(e);
  let n = 0;
  for (let o = 0, d = t.length; o < d; o++) {
    let f = t.charCodeAt(o);
    n = (n << 5) - n + f, n |= 0;
  }
  return `${n}`;
}, Ue = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, Ge = (e, t) => (Array.isArray(e) ? e : [e]).map((n) => {
  const { id: o, type: d, purpose: f, value: A, created: w, modified: C, creator: m, ...S } = n;
  return {
    id: o || `temp-${Le(n)}`,
    annotation: t,
    type: d,
    purpose: f,
    value: A,
    creator: Ue(m),
    created: w ? new Date(w) : void 0,
    updated: C ? new Date(C) : void 0,
    ...S
  };
}), He = (e) => e.map((t) => {
  var w;
  const { annotation: n, created: o, updated: d, ...f } = t, A = {
    ...f,
    created: o == null ? void 0 : o.toISOString(),
    modified: d == null ? void 0 : d.toISOString()
  };
  return (w = A.id) != null && w.startsWith("temp-") && delete A.id, A;
}), We = (e) => "@context" in e && "creator" in e && "body" in e, ye = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], Se = () => {
  const e = [...ye];
  return { assignRandomColor: () => {
    const o = Math.floor(Math.random() * e.length), d = e[o];
    return e.splice(o, 1), d;
  }, releaseColor: (o) => e.push(o) };
}, Te = () => {
  const e = Se();
  return { addUser: (o, d) => {
    const f = e.assignRandomColor();
    return {
      label: d.name || d.id,
      avatar: d.avatar,
      color: f
    };
  }, removeUser: (o) => e.releaseColor(o.appearance.color) };
}, Oe = (e, t) => e.every((n) => e.includes(n)) && t.every((n) => e.includes(n));
globalThis.ANNOTORIOUS_PRESENCE_KEY || (globalThis.ANNOTORIOUS_PRESENCE_KEY = we());
const Qe = globalThis.ANNOTORIOUS_PRESENCE_KEY, qe = (e = Te()) => {
  const t = J(), n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), d = (l, b) => {
    if (n.has(l)) {
      console.warn("Attempt to add user that is already present", l, b);
      return;
    }
    const g = e.addUser(l, b);
    n.set(l, {
      ...b,
      presenceKey: l,
      appearance: g
    });
  }, f = (l) => {
    const b = n.get(l);
    if (!b) {
      console.warn("Attempt to remove user that is not present", l);
      return;
    }
    e.removeUser(b), n.delete(l);
  }, A = (l) => {
    const b = new Set(l.map((L) => L.presenceKey)), g = l.filter(({ presenceKey: L }) => !n.has(L)), E = Array.from(n.values()).filter((L) => !b.has(L.presenceKey));
    g.forEach(({ presenceKey: L, user: O }) => d(L, O)), E.forEach((L) => {
      const { presenceKey: O } = L;
      o.has(O) && t.emit("selectionChange", L, null), f(O);
    }), (g.length > 0 || E.length > 0) && t.emit("presence", m());
  }, w = (l, b) => {
    const g = n.get(l);
    if (!g) {
      console.warn("Activity notification from user that is not present");
      return;
    }
    const E = o.get(l);
    (!E || !Oe(E, b)) && (o.set(l, b), t.emit("selectionChange", g, b));
  }, C = (l, b) => {
    const g = n.get(l);
    if (!g) {
      console.warn("Selection change for user that is not present", l);
      return;
    }
    b ? o.set(l, b) : o.delete(l), t.emit("selectionChange", g, b);
  }, m = () => [...Array.from(n.values())];
  return {
    getPresentUsers: m,
    notifyActivity: w,
    on: (l, b) => t.on(l, b),
    syncUsers: A,
    updateSelection: C
  };
};
export {
  fe as Ignore,
  y as Origin,
  Qe as PRESENCE_KEY,
  ne as UserSelectAction,
  Me as chainStyles,
  Ve as computeStyle,
  je as createAnonymousGuest,
  ze as createBaseAnnotator,
  Ie as createBody,
  Te as createDefaultAppearanceProvider,
  De as createHoverState,
  Pe as createLifecycleObserver,
  qe as createPresenceState,
  Ne as createSelectionState,
  _e as createStore,
  ke as createUndoStack,
  Ye as createViewportState,
  Se as defaultColorProvider,
  q as diffAnnotations,
  xe as getContributors,
  We as isW3CAnnotation,
  ge as mergeChanges,
  oe as onUserSelect,
  me as parseAll,
  Ge as parseW3CBodies,
  Ue as parseW3CUser,
  V as reviveDates,
  $e as serializeAll,
  He as serializeW3CBodies,
  pe as shouldNotify
};
//# sourceMappingURL=annotorious-core.es.js.map
